import { mapGetters, mapState } from 'vuex';
import marketWatch from '@/components/market/market-watch/market-watch.vue';
import constants from '@/constants';


const marketHeaderMixin = {
  components: {
    marketWatch,
  },
  props: {
    market: {
      type: Object,
      required: true,
    },
    watchIcon: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapState('browse', ['currentStoryDetail']),
    isMarketWithinStory() {
      return this.currentStoryDetail !== null;
    },
    watchIconVisible() {
      const statuses = [
        constants.MARKET_EXPIRED,
        constants.MARKET_SETTLED,
      ];
      return this.watchIcon && this.isLoggedIn && !statuses.includes(this.market.status);
    },
  },
};


export default marketHeaderMixin;



// WEBPACK FOOTER //
// ./src/mixins/marketHeader.js